import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import IconCheck from 'static/svg/done-24px.svg'
import { fonts, merchantThemes } from 'components/Variable'

export const OptionItem = styled.button`
	display: block;
	background-color: transparent;
	width: 100%;
	text-align: left;
`
export const SelectStyle = styled.div`
	display: block;
	width: 100%;
	.react-select {
		&__control {
			outline: none;
			width: 100%;
			box-shadow: none;
			border-color: ${({ theme }) => theme.color.blackOne};
			border-radius: ${rem(2)};
			min-height: ${rem(44)};
			background-color: transparent;
			&:hover {
				border-color: ${({ theme }) => theme.color.blackOne};
			}
		}
		&__indicators {
			cursor: pointer;
		}
		&__indicator-separator {
			display: none;
		}
		&__dropdown-indicator {
			padding: ${rem(6, 8)};
			svg {
				width: ${rem(30)};
				height: ${rem(30)};
				fill: ${({ theme }) => theme.color.blackOne};
			}
		}
		&__value-container {
			font-size: ${rem(16)};
			font-weight: 600;
			font-family: ${fonts.openSans};
			padding: ${rem(0, 9)};

			${(p) =>
				p.theme.name === merchantThemes.woodwood &&
				css`
					font-family: ${fonts.WWBeta8Regular};
				`}

			${(p) =>
				p.theme.name === merchantThemes.hh &&
				css`
					font-family: ${fonts.dinPro};
				`}
             
            ${(p) =>
				p.theme.name === merchantThemes.marysia &&
				css`
					font-family: ${fonts.futura};
				`}
			 ${(p) =>
				p.theme.name === merchantThemes['8848'] &&
				css`
					font-family: ${fonts.futura};
				`}
			${(p) =>
				p.theme.name === merchantThemes.aycane &&
				css`
					font-family: ${fonts.IBMPlex};
				`}
			${(p) =>
				p.theme.name === merchantThemes.bymalina &&
				css`
					font-family: ${fonts.Avenir};
				`}
			${(p) =>
				p.theme.name === merchantThemes.henrylloyd &&
				css`
					font-family: ${fonts.Gotham};
				`}
			${(p) =>
				p.theme.name === merchantThemes.chimi &&
				css`
					font-family: ${fonts.AmericaExpandedRegular};
				`}
			${(p) =>
				p.theme.name === merchantThemes.ogoship &&
				css`
					font-family: ${fonts.usual};
				`}
				${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					font-family: ${fonts.MonumentGrotesk};
					font-weight: normal;
				`}
				${(p) =>
				p.theme.name === merchantThemes.sns &&
				css`
					font-family: ${fonts.AktivGroteskEx};
				`}
		}
		&__single-value,
		&__placeholder {
			color: ${({ theme }) => theme.color.blackOne};
		}

		&__menu {
			margin-top: ${rem(3)};
			box-shadow: none;
			border: 1px solid ${({ theme }) => theme.color.blackOne};
			border-radius: ${rem(2)};
		}

		&__option {
			font-size: ${rem(18)};
			color: ${({ theme }) => theme.color.grayThree};
			font-weight: 600;
			padding: ${rem(3, 9)};
			cursor: pointer;
			&--is-focused {
				background-color: #f6f6f6;
			}
			&--is-selected {
				background: ${({ theme }) => theme.color.primary}
					url(${IconCheck}) no-repeat center right ${rem(18)};
				color: ${({ theme }) => theme.color.secondary};
			}
			&--is-disabled {
				background-color: ${({ theme }) => theme.color.secondary};
				color: ${({ theme }) => theme.color.grayOne};
			}
		}
		&--is-disabled {
			.react-select__indicators {
				display: none;
			}
		}
	}
	${(p) =>
		p.isEmpty &&
		css`
			.react-select {
				&__control {
					border-color: ${({ theme }) => theme.color.redOne};
					&:hover {
						border-color: ${({ theme }) => theme.color.redOne};
					}
				}
			}
		`}
`
